module.exports = __webpack_public_path__ + "static/media/mf.3a548eed.svg";